import colors from '../../colors.json'
import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const WOW: Dashboard = {
    id: 'WOW',
    name: 'MDA Screens',
    daterange: true,
    metrics: [
        {
            type: Metrics.WOW_DWELLTIMELINE_PRODUCTS,
            'box-size': BoxSizes.BIG,
            chart: Chart.Timeline,
            color: [colors.bluelight, colors.orange, '#bb5ee0', '#56bbc5'],
            legend: true,
            title: 'dashboard-wow-dwelltimeline-products',
            count: 'dashboard-count-installations',
        },
        {
            type: Metrics.WOW_BUTTONS,
            'box-size': BoxSizes.BIG,
            chart: Chart.Bars,
            title: 'dashboard-wow-buttons',
            count: 'dashboard-count-touches',
        },
        {
            type: Metrics.WOW_DWELLTIME,
            'box-size': BoxSizes.MID,
            chart: Chart.Bars,
            title: 'dashboard-wow-dwelltime',
            count: 'dashboard-count-seconds-average',
        },
        {
            type: Metrics.WOW_SESSIONS_COUNT,
            'box-size': BoxSizes.MID,
            chart: Chart.Bars,
            title: 'dashboard-wow-sessions-count',
            count: 'dashboard-count-sessions-average',
        },
        {
            type: Metrics.WOW_STORES_TOP,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-stores-top',
            count: 'dashboard-count-stores',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.MID,
            metrics: [
                {
                    type: Metrics.WOW_MEDIA_TOP,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-media-top',
                },
                {
                    type: Metrics.WOW_INSTALLATIONS_TOP,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-wow-installations-top',
                },
            ],
        },
    ],
}

export default WOW
